import { Button, Icon } from '@smartgift/frontend-toolkit';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { VerticalDivider } from '@hero/atoms';
import { PageLayout } from '@hero/components/layouts';
import { InviteUserModal } from '@hero/components/modals';
import { OrganizationUsersTable, SettingsTabs } from '@hero/components/organisms';
import { configs } from '@hero/configs';
import {
  useGetOrganizationUserCount,
  useResendOrganizationUser
} from '@hero/services/organization-service/hooks';
import { useNotification } from '@hero/store/hooks';

import * as S from './style';

export default function Users() {
  const { t } = useTranslation();
  const { showNotification } = useNotification();
  const { data: organizationUsersCount } = useGetOrganizationUserCount();
  const { mutateAsync: resendOrganizationUser } = useResendOrganizationUser();

  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);

  const { owner = 0, admin = 0, user = 0 } = organizationUsersCount?.countsByRole || {};

  return (
    <PageLayout
      header={{
        title: t('users')
      }}
    >
      <SettingsTabs />
      <S.Users>
        <S.TableHeader>
          <S.TableHeaderTitle>
            <S.TableHeaderTitleText>
              <strong>{t('userTotal', { count: owner + admin + user })}:</strong>
            </S.TableHeaderTitleText>
            {!!owner && (
              <S.TableHeaderTitleText>
                <strong>{owner}</strong> {t('owner', { count: owner })}
                {(!!admin || !!user) && ','}
              </S.TableHeaderTitleText>
            )}
            {!!admin && (
              <S.TableHeaderTitleText>
                <strong>{admin}</strong> {t('admin', { count: admin })}
                {!!user && ','}
              </S.TableHeaderTitleText>
            )}
            {!!user && (
              <S.TableHeaderTitleText>
                <strong>{user}</strong> {t('member', { count: user })}
              </S.TableHeaderTitleText>
            )}
          </S.TableHeaderTitle>
          <VerticalDivider $height="20px" $margin="0 8px" />
          {configs?.users?.userInvite && (
            <>
              <Button
                variant="link"
                startIcon={<Icon name="email" />}
                disabled={(organizationUsersCount?.countsByStatus?.pending || 0) === 0}
                onClick={() => {
                  showNotification({
                    header: t('resendUserInvitations'),
                    message: t('resendUserInvitationMessage'),
                    notificationImage: <Icon name="email" size="xxl" />,
                    secondaryButtonProps: { children: t('cancel') },
                    primaryButtonProps: { children: t('send') },
                    onSubmit: () => {
                      resendOrganizationUser();
                    }
                  });
                }}
              >
                {t('resendInvitations')}
              </Button>
              <VerticalDivider $height="20px" $margin="0 8px" />
              <Button
                variant="link"
                startIcon={<Icon name="add-contact" />}
                onClick={() => setIsInviteModalOpen(true)}
              >
                {t('inviteUsers')}
              </Button>
            </>
          )}
        </S.TableHeader>
        <OrganizationUsersTable />
        {isInviteModalOpen && (
          <InviteUserModal isOpen={isInviteModalOpen} setIsOpen={setIsInviteModalOpen} />
        )}
      </S.Users>
    </PageLayout>
  );
}

export { Users };
